import type { RootState } from './RootReducer';
import type { BlockchainMeta, SwapperMeta, TokenMeta } from '../api/models/MetaModels';
import type { PayloadAction } from '@reduxjs/toolkit';

import { convertEvmBlockchainMetaToEvmChainInfo } from '@rango-dev/internal-blockchains';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { isEvmBlockchain } from 'rango-types';

export type MetaState = {
  loadingStatus: 'loading' | 'success' | 'failed';
  tokens: TokenMeta[];
  blockchains: BlockchainMeta[];
  swappers: SwapperMeta[];
};

const initialState: MetaState = {
  tokens: [],
  blockchains: [],
  swappers: [],
  loadingStatus: 'loading',
};

export const metaSlice = createSlice({
  name: 'meta',
  initialState,
  reducers: {
    setMeta: (state, action: PayloadAction<MetaState>) => {
      state.blockchains = action.payload.blockchains;
      state.tokens = action.payload.tokens;
      state.swappers = action.payload.swappers;
      state.loadingStatus = action.payload.loadingStatus;
    },
  },
});

export const MetaReducer = metaSlice.reducer;
export const { setMeta } = metaSlice.actions;

export type { EvmNetworksChainInfo } from '@rango-dev/internal-blockchains';

const allBlockchainsSelector = (state: RootState) => state.meta.blockchains;

export const evmBasedChainsSelector = createSelector(
  allBlockchainsSelector,
  (blockchains: BlockchainMeta[]) => blockchains.filter(isEvmBlockchain),
);

export const evmBasedChainsNamesSelector = createSelector(
  allBlockchainsSelector,
  (blockchains: BlockchainMeta[]) =>
    blockchains.filter(isEvmBlockchain).map((blockchainMeta) => blockchainMeta.name),
);

export const sortedBlockchainSelector = createSelector(
  allBlockchainsSelector,
  (blockchains: BlockchainMeta[]) => [...blockchains].sort((a, b) => a.sort - b.sort),
);

export const evmNetworksChainInfoSelector = createSelector(
  evmBasedChainsSelector,
  convertEvmBlockchainMetaToEvmChainInfo,
);
